export enum ListingTypeEnum {
  Sale = 'Sale',
  Rental = 'Rental',
}

export enum CMSListingTypeEnum {
  Achat = 'Achat',
  Location = 'Location'
}

export const listingTypeEnumNumericValue: Record<ListingTypeEnum, number> = {
  [ListingTypeEnum.Sale]: 0,
  [ListingTypeEnum.Rental]: 1
};

export const listingTypeEnumNumericValueFromCMS: Record<CMSListingTypeEnum, number> = {
  [CMSListingTypeEnum.Achat]: 0,
  [CMSListingTypeEnum.Location]: 1
};

export const listingTypeLabels = {
  [ListingTypeEnum.Sale]: 'Vente',
  [ListingTypeEnum.Rental]: 'Location'
};
